import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import DashboardPage from "./pages/dashboard/dashboard-page";
import ConversationsPage from "./pages/conversations/conversations-page";
import { Layout } from "./layouts";
import { LayoutProvider } from "./core/context/layout-context";
import { ThemeProvider } from "./core/context/theme-context";
//import CampagnesPage from "./pages/campagnes/campagne-page";
import CampagnesPage from "./pages/campagnes/campagne-page";
import CrmClientPage from "./pages/crm-client/crm-client-page";

//import {CrmClientPage as CrmClient} from "./pages/crm-client/crm-client-page";

import FinancePage from "./pages/finance/finance-page";
import BigDataPage from "./pages/big-data/bigdata-page";
import LoginPage from "./pages/authentication/login-page";
import  AuthProvider  from 'react-auth-kit';
import createStore from 'react-auth-kit/createStore';
import ReservationsPage from "./pages/reservations/reservation-page";
import ExpeditionsPage from "./pages/expeditions/expeditions-page";
import { ToastContainer } from "react-toastify";
// import { useLayoutContext } from "./core/context/layout-context";

function App() {
  const store = createStore({
    authName: '_auth',
    authType: 'localstorage',
  });

  // const layouContext = useLayoutContext();

  return (
    <>
      <AuthProvider store={store} 
        >
          <BrowserRouter>
            <ThemeProvider>
              <LayoutProvider>
                <Routes>
                  <Route path="/" element={<LoginPage />} />
                  <Route
                    path="/dashboard"
                    element={
                      <Layout>
                        <DashboardPage />
                      </Layout>
                    }
                  />
                  <Route
                    path="/conversations"
                    element={
                      <Layout>
                        <ConversationsPage />
                      </Layout>
                    }
                  />
                  <Route
                    path="/campagnes"
                    element={
                      <Layout>
                        <CampagnesPage />
                      </Layout>
                    }
                  />
                  <Route
                    path="/crm-client"
                    element={
                      <Layout>
                        <CrmClientPage />
                      </Layout>
                    }
                  />
                  <Route
                    path="/finance"
                    element={
                      <Layout>
                        <FinancePage />
                      </Layout>
                    }
                  />
                  <Route
                    path="/bigdata"
                    element={
                      <Layout>
                        <BigDataPage />
                      </Layout>
                    }
                  />
                  <Route
                    path="/reservations"
                    element={
                      <Layout>
                        {/* <BigDataPage /> */}
                        <ReservationsPage />
                      </Layout>
                    }
                  />
                  <Route
                    path="/expeditions"
                    element={
                      <Layout>
                        <ExpeditionsPage />
                      </Layout>
                    }
                  />
                  
                </Routes>
              </LayoutProvider>
            </ThemeProvider>
            <ToastContainer
              position="top-right"
              autoClose={3500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </BrowserRouter>
        </AuthProvider>
    </>
  );
}

export default App;
